import { Container, Button } from '@chakra-ui/react'
import { ApiKeyDetails } from '@features/apiKeys/components/ApiKeyDetails'
import { createFileRoute, Link, useParams } from '@tanstack/react-router'
import { Route as listApiKeyRoute } from '@routes/_auth/orgs/$orgId/apiKeys'
import { FaArrowLeft } from 'react-icons/fa6'

const BackButton = () => {
  const { orgId } = useParams({
    from: '/_auth/orgs/$orgId/apiKeys/$name',
  })
  return (
    <Link to={listApiKeyRoute.to} params={{ orgId }}>
      <Button leftIcon={<FaArrowLeft />} size="xs">
        Back to List
      </Button>
    </Link>
  )
}

const ApiKeyDetailRoute = () => {
  const { orgId, name } = useParams({
    from: '/_auth/orgs/$orgId/apiKeys/$name',
  })
  return (
    <Container maxW={'75rem'}>
      <BackButton />
      <ApiKeyDetails orgId={orgId} name={name} />
    </Container>
  )
}

export const Route = createFileRoute('/_auth/orgs/$orgId/apiKeys/$name')({
  component: ApiKeyDetailRoute,
  beforeLoad: () => ({ getTitle: () => 'API Keys' }),
  loader: () => ({
    crumb: 'Details',
  }),
})
